var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},[_vm._m(0),_vm._l((_vm.projectList),function(project){return _c('project-list-item',{key:project.id,attrs:{"project":project}})})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main__title-wrapper h2-wrapper"},[_c('a',{attrs:{"name":"work"}}),_c('h2',{staticClass:"main__title"},[_vm._v("Selected Work")])])
}]

export { render, staticRenderFns }